"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _Back = _interopRequireDefault(require("./Back"));

var _Item = _interopRequireDefault(require("./Item"));

var _ReactBreadcrumb = _interopRequireDefault(require("./ReactBreadcrumb.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactBreadcrumb = function ReactBreadcrumb(_ref) {
  var backIcon = _ref.backIcon,
      backLabel = _ref.backLabel,
      _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? "sm" : _ref$breakpoint,
      data = _ref.data,
      homeIcon = _ref.homeIcon,
      homeLabel = _ref.homeLabel,
      homeLink = _ref.homeLink,
      separator = _ref.separator,
      _ref$showBackButton = _ref.showBackButton,
      showBackButton = _ref$showBackButton === void 0 ? false : _ref$showBackButton,
      _ref$showCurrentPage = _ref.showCurrentPage,
      showCurrentPage = _ref$showCurrentPage === void 0 ? true : _ref$showCurrentPage;
  var theme = (0, _useTheme.default)();
  var isLargeScreen = (0, _useMediaQuery.default)(theme.breakpoints.up(breakpoint));
  var css = (0, _ReactBreadcrumb.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.breadcrumb, "mco-breadcrumb")
  }, backLabel && showBackButton && !isLargeScreen && /*#__PURE__*/_react.default.createElement(_Back.default, {
    icon: backIcon,
    label: backLabel
  }), (!showBackButton || showBackButton && isLargeScreen) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, homeLabel && homeLink && /*#__PURE__*/_react.default.createElement(_Item.default, {
    label: homeLabel,
    link: homeLink,
    icon: homeIcon,
    type: "menu"
  }), data === null || data === void 0 ? void 0 : data.map(function (item, counter) {
    var id = item.id,
        title = item.title,
        link = item.link,
        type = item.type;

    if (!showCurrentPage && type === "page") {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    return /*#__PURE__*/_react.default.createElement(_Item.default, {
      key: id !== null && id !== void 0 ? id : counter,
      icon: separator,
      label: title,
      link: link,
      type: type
    });
  })));
};

ReactBreadcrumb.propTypes = {
  backIcon: _propTypes.default.object,
  backLabel: _propTypes.default.string,
  breakpoint: _propTypes.default.string,
  data: _propTypes.default.array.isRequired,
  homeIcon: _propTypes.default.object,
  homeLabel: _propTypes.default.string,
  homeLink: _propTypes.default.string,
  separator: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  showBackButton: _propTypes.default.bool,
  showCurrentPage: _propTypes.default.bool
};
var _default = ReactBreadcrumb;
exports.default = _default;